export default {
  "route": {
    "title": "Sistema de publicación de información",
    "home": "Inicio",
    "terminal": "Terminal",
    "program": "Programa",
    "h5program": "Programa",
    "my": "Mi",
    "remote_control": "Control remoto",
    "task_details": "Detalles de la tarea",
    "add_task": "Agregar tarea",
    "program_list": "Lista de programas",
    "terminal_info": "Información del terminal",
    "add_resolution": "Agregar resolución",
    "add_program": "Agregar programa",
    "material_management": "Gestión de materiales",
    "create_program": "Crear programa",
    "login": "Iniciar sesión",
    "reset_password": "Restablecer contraseña",
    "change_password": "Cambiar contraseña",
    "preview": "Vista previa"
  },
  append_field:{
    "input_code": "Por favor, ingrese el código de verificación",
    "code_error": "Error de código de verificación",
    "fill_code": "Por favor, ingrese el código de verificación",
    "dOut": "Rotación 3D hacia afuera",
    "dIn": "Rotación 3D hacia adentro",
    "dxiao": "Efecto de marco 3D",
    "selectImage": "Por favor, seleccione una imagen",
    "onlySelectOneImage": "Solo puede seleccionar una imagen",
    "imageFormatError": "Error de formato de imagen",
    "cancel": "Cancelar",
    "selectedNumber": "Seleccionado",
    "confirm": "Confirmar",
    "loadinga": "Cargando...",
    "loadingb": "Cargando",
    "uploading": "Subiendo",
    "selectStartDates": "Seleccione la fecha de inicio",
    "selectEndDates": "Seleccione la fecha de finalización",
    "createTask": "Crear nueva tarea",
    "selectPrograms": "Seleccionar programas",
    "createPrograms": "Crear programa",
    "editTask": "Editar tarea",
    "fillTaskName": "Por favor, ingrese el nombre",
    "selectTaskGroup": "Por favor, seleccione el grupo de tareas",
    "selectProgram": "Por favor, seleccione el programa",
    "selected": "Seleccionado",
    "programs": "programas",
    "selectDevice": "Por favor, seleccione el dispositivo",
    "sendTaskSuccess": "Tarea enviada con éxito",
    "taskName": "Nombre",
    "playMode": "Modo de reproducción",
    "replaceMode": "Modo de sustitución",
    "appendMode": "Modo de adición",
    'apotpatterns': 'Modo de inserción',
    "dateRange": "Fechas de reproducción",
    "timeRange": "Horas de reproducción",
    "taskPeriod": "Especifique el día de la semana",
    "mon": "Lun",
    "tue": "Mar",
    "wed": "Mié",
    "thu": "Jue",
    "fri": "Vie",
    "sat": "Sáb",
    "sun": "Dom",
    "back": "Regresar",
    "programList": "Lista de programas",
    "deviceList": "Lista",
    "enterContent": "Por favor, ingrese el contenido",
    "taskGroup": "Grupo de tareas",
    "selectStartDate": "Seleccione la fecha de inicio",
    "selectEndDate": "Seleccione la fecha de finalización",
    "selectStartTime": "Seleccione la hora de inicio",
    "selectEndTime": "Seleccione la hora de finalización",
    "addTask": "Agregar tarea",
    "topLeft": "Superior izquierda",
    "topCenter": "Centro superior",
    "topRight": "Superior derecha",
    "leftCenter": "Centro izquierda",
    "center": "Centro",
    "rightCenter": "Centro derecha",
    "bottomLeft": "Inferior izquierda",
    "bottomCenter": "Centro inferior",
    "bottomRight": "Inferior derecha",
    "enterText": "Por favor, ingrese el texto",
    "fontColor": "Color de fuente",
    "bgColor": "Color de fondo",
    "scrollDirection": "Desplazamiento",
    "scrollSpeed": "Velocidad",
    "fontSize": "Tamaño de fuente",
    "alignment": "Alineación",
    "subtitle": "Subtítulo",
    "enterURL": "Por favor, ingrese la URL",
    "webPage": "Página web",
    "enterMediaURL": "Por favor, ingrese la dirección de streaming",
    "media": "Streaming",
    "selectVideo": "Por favor, seleccione un video",
    "unsupportedFormat": "Formato de archivo no compatible. Actualmente se admiten archivos '.png', '.jpg', '.jpeg', '.gif', '.mp4', '.avi', '.mov', '.mkv','mp3','.pdf','xls','xlsx'",
    "cancelAllSelections": "Cancele todas las selecciones antes de subir un nuevo archivo",
    "fileName": "Nombre del archivo",
    "fileSize": "Tamaño del archivo",
    "uploadProgress": "Progreso de la carga",
    "cancelUpload": "Cancelar carga",
    "cancelAllUploads": "Cancelar todas las cargas",
    "leftToRights": "Izquierda",
    "rightToLefts": "Derecha",
    "bottomToTops": "Arriba",
    "static": "Estático",
    "slow": "Lento",
    "medium": "Medio",
    "fast": "Rápido",
    "colorValue": "Valor del color",
    "defaultEffect": "Efecto predeterminado",
    "rightToLeft": "De derecha a izquierda",
    "leftToRight": "De izquierda a derecha",
    "topToBottom": "De arriba hacia abajo",
    "bottomToTop": "De abajo hacia arriba",
    "accordionSqueeze": "Compresión de acordeón",
    "zoomInFade": "Zoom in ",
    "zoomOutFade": "Zoom out ",
    "depthOfField": "Profundidad de campo",
    "leftRightRotate": "Rotación izquierda-derecha",
    "upDownRotate": "Rotación arriba-abajo",
    "counterclockwiseRotate": "Antihorario",
    "clockwiseRotate": "Rotación en sentido horario",
    "upDownZoom": "Zoom arriba-abajo",
    "scaleFade": "Escala de desvanecimiento",
    "zoomInDisappearing": "Desaparición",
    "transparentFade": "Transparente",
    "gradientScale": "Escala de gradiente",
    "deleteMaterial": "Eliminar material",
    "confirmDeleteMaterial": "¿Confirmar eliminación de este material?",
    "unreviewed": "No revisado",
    "normal2": "Normal",
    "violating": "Violando",
    "suspectedViolating": "Sospecha de violación",
    "delete": "Eliminar",
    "selectMaterial": "Seleccione material",
    "deleteProgramGroup": "Eliminar grupo de programa",
    "confirmDeleteGroup": "¿Confirmar eliminación de este grupo?",
    "add": "Agregar",
    "toggle_effect": "Efecto",
    "toggle_time": "Alternar tiempo",
    "pub_toggle_time": "Alternancia",
    "fullscreen": "Completa",
    "normal": "Normal",
    "interactive": "Interactivo",
    "main_screen": "Pantalla principal",
    "sub_screen": "Pantalla secundaria",
    "dual_screen": "Pantalla dual",
    "sync_task": "Sincronizar tarea",
    "normal_mode": "Modo normal",
    "basic_info": "Información básica",
    "program_info": "Información del programa",
    "task_name": "Nombre",
    "task_type": "Tipo de tarea",
    "pub_task": "Tarea normal",
    "hu_task": "Tarea interactiva",
    "no_data": "Sin datos",
    "no_msg": "Sin información",
    "program_name": "Nombre",
    "program_resolution": "Resolución del programa",
    "program_type": "Tipo de programa",
    "screen_category": "Categoría de pantalla",
    "edit_program": "Editar programa",
    "edit": "Editar",
    "send": "Enviar",
    "create": "Crear grupo",
    "reload": "Recargar",
    "name": "Nombre",
    "create_task_z": "Crear grupo de tareas",
    "ps_push_name": "Ingrese el nombre del grupo",
    "device_list": "Lista de dispositivos",
    "delete_task_group": "Eliminar grupo de tareas",
    "confirm_delete_group": "¿Confirmar eliminación de este grupo?",
    "delete_success": "Eliminación exitosa",
    "name_cannot_be_empty": "El nombre no puede estar vacío",
    "character_length_limit": "La longitud del carácter debe ser de hasta 10 caracteres",
    "create_task_success": "Creación de tarea exitosa",
    "create_task_failed": "Creación fallida",
    "confirm_delete_task": "¿Está seguro de que desea eliminar la tarea?",
    "task_details": "Detalles de la tarea",
    "download_success": "Descarga exitosa",
    "waiting_download": "Esperando descarga",
    "downloading": "Descargando",
    "confirm_delete": "¿Está seguro de que desea eliminar?",
    "confirm_delete_all": "¿Está seguro de que desea eliminar todo?",
    "confirm_delete_selected": "¿Está seguro de que desea eliminar la selección?",
    "no_data_to_clear": "¡No hay datos para limpiar!",
    "refresh": "Actualizar",
    "clear_all": "Limpiar todo",
    "clear_completed": "Limpiar",
    "device_id": "ID",
    "task_size": "Tamaño",
    "speed": "Velocidad",
    "download_progress": "Progreso de la descarga",
    "title": "Título",
    "volume": "Volumen",
    "deleteP": "Eliminar programa",
    "con_P": "¿Confirmar eliminación de este programa?",
    "clear": "Vaciar",
    "download_status": "Estado de la descarga",
    "height_width_cannot_be_empty": "La altura/ancho no puede estar vacío",
    "add_success": "Adición exitosa",
    "enter_number_between_300_to_8000": "Ingrese un número entre 300 y 8000",
    "width": "Ancho",
    "enter_width": "Ingrese el ancho",
    "height": "Altura",
    "enter_height": "Ingrese la altura",
    "confirm_leave_page": "¿Está seguro de que desea salir de esta página?",
    "add_content_to_control": "Agregue contenido al control",
    "add_control": "Agregue control",
    "save_success": "Guardado exitoso",
    "save": "Guardar",
    "create_program": "Crear programa",
    "guess": "Adivina",
    "modify": "Modificar",
    "text": "Texto",
    "image": "Imagen",
    "background_image": "Imagen de fondo",
    "background_music": "Música de fondo",
    "replace": "Reemplazar",
    "use_this_template": "Usar esta plantilla",
    "apply_template": "Aplicar plantilla",
    "enter_program_name": "Ingrese el nombre del programa",
    "program_group": "Grupo de programas",
    "select_program_group": "Seleccione el grupo de programas",
    "group_list": "Lista de grupos",
    "preview": "Vista previa",
    "my_apps": "Mis aplicaciones",
    "template_center": "Centro de plantillas",
    "home": "Inicio",
    "source_of_visit": "Fuente de visita",
    "online": "En línea",
    "terminal_status": "Estado",
    "memory_status": "Estado de la memoria",
    "login": "Iniciar sesión",
    "sms_verification": "Verificación por SMS",
    "email_verification": "Verificación por correo electrónico",
    "log_in": "Iniciar sesión",
    "enter_username": "Ingrese su cuenta",
    "username_cannot_be_empty": "El nombre de usuario no puede estar vacío",
    "password_cannot_be_empty": "La contraseña no puede estar vacía",
    "incorrect_phone_format_for_verification_code": "El formato del número de teléfono para el código de verificación es incorrecto. ¡Por favor, contacte al administrador para corregirlo!",
    "incorrect_email_format_for_verification_code": "El formato del correo electrónico para el código de verificación es incorrecto. ¡Por favor, contacte al administrador para corregirlo!",
    "incorrect_phone_or_email_format_for_verification_code": "El formato del correo electrónico o del teléfono para el código de verificación es incorrecto. ¡Por favor, contacte al administrador para corregirlo!",
    "reset_password": "Restablecer contraseña",
    "remember_password": "Recordar contraseña",
    "register": "Registrar cuenta",
    "current_version_4.1.6": "V4.1.8",
    "notification_about_network_security": "Notificación sobre seguridad de la red",
    "got_it": "Entendido",
    "please_authenticate_for_account_safety": "Para la seguridad de su cuenta, por favor autentíquese",
    "enter_account": "Ingrese su cuenta",
    "enter_password": "Ingrese su contraseña",
    "verification_code": "Código de verificación",
    "none": "Ninguno",
    "personal_center": "Centro personal",
    "remote_control": "Control remoto",
    "refresh_success": "¡Actualización exitosa!",
    "logout": "Cerrar sesión",
    "confirm_logout": "¿Está seguro de que desea cerrar sesión?",
    "user_status": "Estado del usuario",
    "customer_address": "Dirección del cliente",
    "account_period": "Período de la cuenta",
    "device_control": "Control remoto del dispositivo",
    "clear_cache": "Borrar caché",
    "exit": "Salir",
    "terminal": "Terminal",
    "program": "Programa",
    "material": "Material",
    "my": "Mi",
    "display_type": "Tipo de pantalla",
    "proportion": "Escala",
    "resolution": "Resolución",
    "screen_orientation": "Orientación de pantalla",
    "landscape": "Horizontal",
    "portrait": "Vertical",
    "add_resolution": "Agregar resolución",
    "execute_formatting_when_focus_lost": "Ejecutar formateo al perder enfoque",
    "select_resolution": "Seleccione la resolución",
    "resolution_list": "Lista de resoluciones",
    "confirm_delete_program": "¿Está seguro de que desea eliminar el programa?",
    "confirm_delete_this_program": "¿Está seguro de que desea eliminar este programa?",
    "bound_tasks_exists_confirm_delete": "Existen tareas vinculadas, ¿está seguro de que desea eliminar?",
    "prompt": "Sugerencia",
    "delete_failed": "Eliminación fallida",
    "modification_time": "Hora de modificación",
    "resolution_": "Resolución",
    "associated_tasks": "Tareas asociadas",
    "bound_task": "Tarea vinculada",
    "program_management": "Gestión de programas",
    "task": "Tarea",
    "progress": "Progreso",
    "phone_number": "Número de teléfono",
    "enter_phone_number": "Ingrese el número de teléfono",
    "password": "Contraseña",
    "confirm_password": "Confirmar contraseña",
    "enter_password_again": "Ingrese la contraseña nuevamente",
    "company_name": "Nombre de la empresa",
    "enter_company_name": "Ingrese la información de su empresa",
    "address": "Dirección",
    "enter_address": "Ingrese la dirección de contacto",
    "username_not_exist": "El nombre de usuario no existe",
    "enter_new_password": "Ingrese una nueva contraseña",
    "enter_new_password_again": "Ingrese la nueva contraseña nuevamente",
    "terminal_management": "Gestión del terminal",
    "delete_group": "Eliminar grupo",
    "pel_select_group": "Seleccione un grupo",
    "enter_device_name": "Ingrese el nombre del dispositivo",
    "delete_device": "Eliminar dispositivo",
    "confirm_delete_device": "¿Confirmar eliminación de este dispositivo?",
    "terminal_information": "Información del terminal",
    "qr_code_error": "Error en el código QR",
    "device_not_supported": "Dispositivo no soportado",
    "device_offline": "El dispositivo seleccionado debe estar en línea para enviar comandos, ¡por favor seleccione nuevamente!",
    "more": "Más",
    "device_access": "Acceso al dispositivo",
    "filter": "Filtrar",
    "all": "Todo",
    "offline": "Fuera de línea",
    "device_name": "Nombre del dispositivo",
    "device_number": "Número del dispositivo",
    "device_group": "Grupo de dispositivos",
    "call_device_please_wait": "Llamando al dispositivo, por favor espere...",
    "create_terminal_group": "Crear nuevo grupo de dispositivos",
    "enter_search_keyword": "Ingrese la palabra clave de búsqueda",
    "bind_device": "Vincular dispositivo",
    "select_device_group": "Seleccione un grupo de dispositivos",
    "authorized": "Autorizado",
    "unauthorized": "No autorizado",
    "adjust_volume": "Ajustar el volumen",
    "reboot_device": "Reiniciar el dispositivo",
    "wake_up": "Activación",
    "sleep": "Suspensión",
    "shutdown": "Apagado",
    "clean_up_timing_on_off": "Programa de limpieza",
    "clean_up_disk": "Limpiar disco",
    "clean_up_task": "Limpiar tarea",
    "send_command": "Enviar comando",
    "confirm2": "¿Enviar?",
    "terminal_operation": "Operación del terminal",
    "bind_task": "Información tarea",
    "remote_command": "Comando remoto",
    "remote_monitor": "Monitoreo remoto",
    "adding_one_will_override_the_previous": "Solo se permite agregar un registro de tiempo, se sobrescribirá el anterior",
    "screenshot_in_progress_please_wait": "Capturando pantalla, por favor espere",
    "schedule_on_off": "Encendido/apagado programado",
    "shutdown_time": "Hora de apagado",
    "startup_time": "Hora de encendido",
    "volume_setting": "Configuración de volumen",
    "edit_device_name": "Editar nombre del dispositivo",
    "please_select_time": "Seleccione la hora",
    "device_not_online_please_retry": "El dispositivo no está en línea, por favor intente de nuevo",
    "sent_successfully": "Enviado con éxito",
    "version": "V4.1.8",
    "texta": "Texto",
    "userName": "Cuenta",
    "email": "Correo electrónico",
    "device_memory": "Memoria del dispositivo",
    "device": "Dispositivo",
    "device_mac": "MAC del dispositivo",
    "screen_count": "Número de pantallas",
    "device_location": "Ubicación del dispositivo",
    "is_authorized": "¿Está autorizado?",
    "remark": "Observación",
    "device_ip": "IP del dispositivo",
    "system_version": "Versión del sistema",
    "playback_date": "Fecha de reproducción",
    "playback_period": "Periodo de reproducción",
    "retrieve_again": "Recuperar nuevamente",
    "please_enter_password": "¡Ingrese una contraseña de más de 8 caracteres que contenga números, letras y caracteres especiales [@#$%^&+=]!",
    "passwords_do_not_match": "Las contraseñas ingresadas no coinciden",
    "enter_new_password2": "Ingrese una nueva contraseña",
    "current_password_too_simple": "La contraseña actual es demasiado simple, por favor cambie la contraseña lo antes posible, ingrese caracteres de más de 8 dígitos que contengan números, letras y caracteres especiales [@#$%^&+=]",
    "creation_time": "Hora de creación",
    "login2": "Iniciar sesión",
    "welcome": "Bienvenido al inicio de sesión",
    "expired_login": "La autenticación ha expirado, por favor inicie sesión nuevamente.",
    "control": "Control remoto",
    "add_task": "Agregar tarea",
    "program_list": "Lista de programas",
    "terminal_info": "Información del terminal",
    "add_program": "Agregar programa",
    "material_management": "Gestión de materiales",
    "change_password": "Cambiar contraseña",
    "enter_text_content": "Ingrese el contenido del texto",
    "hit_the_wall_on_back": "Al retroceder hay una pared",
    "last_ceremony": "Última ceremonia",
    "already_top_level": "Ya está en el nivel más alto",
    "already_last_one": "Ya es la última vez",
    "white_fox": "Zorro blanco",
    "control_img": "Imagen",
    "control_video": "Video",
    "control_streaming": "Streaming",
    "control_webPage": "Página web",
    "control_subtitle": "Subtítulos",
    "control_HDMI": "HDMI",
    "control_addbackground": "Fondo",
    "Up": "Subir",
    "onlyOne": "El control solo puede agregar uno",
    "clearBg": "Eliminar fondo",
    "get_code": "Por favor ingrese primero el código de verificación",
    "del_Null_Program": "¿Desea limpiar el programa vacío en la lista?",
    "please_select_date": "Seleccione al menos una fecha",
    "last_size": "Espacio restante",
    "shutdown_tips": "No se puede encender remotamente después de apagar",
    "last_size_upload": "Por favor, seleccione nuevamente.",
    "end_date_earlier_than_start_date": "La fecha de finalización no puede ser anterior a la fecha de inicio",
    "account_type": "Tipo de usuario",
    "user_type": "Usuario normal",
    "role_type": "Rol",
    "super_administrator": "Superadministrador",
    "term_info_empty": "La información del terminal está vacía",
    "select_terminal_prompt": "Haga clic en el botón de lista en la esquina superior derecha para seleccionar el terminal",
    "select": "Seleccionar",
    "data_empty": "¡Los datos están vacíos!",
    "content_review": "Revisión de contenido",
    "start_date": "Fecha de inicio",
    "end_date": "Fecha de finalización",
    "start_time": "Hora de inicio",
    "end_time": "Hora de finalización",
    "select_all": "Todo",
    "select_group": "Seleccionar grupo",
    "review": "Revisar",
    "material_type": "Tipo de material",
    "audio": "Audio",
    "document": "Archivo",
    "material_status": "Estado del material",
    "material_review": "Revisión del material",
    "current_selection_requires_review": "El material seleccionado actualmente, ¿requiere revisión?",
    "invCode": "Código de invitación",
    "tip_invitation_empty": "Por favor, ingrese el código de invitación",
    "enter_userName": "Por favor, ingrese la cuenta del usuario",
    "enter_email": "Por favor, ingrese el correo electrónico",
    "file_less_38": "El archivo debe ser menor de 38KB",
    "viewError": "Este archivo no admite vista previa",
    "user": "Información personal",
    "phone_number_too_short": "La longitud del número de teléfono debe ser mayor a 9 dígitos",
    "oneImage": "La imagen de fondo ya existe, si desea volver a cargarla, primero elimínela",
    "del_title": "Confirmar eliminación",
    "del_message": "¿Está seguro de que desea eliminar el control?",
    "close": "Cerrar",
    "exit_group_name": "Editar nombre del grupo",
    "group_management": "Grupos",
    "language": "Cambio de idioma",
    "mixture": "Mezcla",
    "date": "Fecha",
    "weeks": "Semana",
    "time": "Hora",
    "new_password": "Nueva contraseña",
    "enter_invCode": "Consejo: solicite el código de invitación al administrador superior",
    "msg_password": "Consejo: ¡ingrese una contraseña de más de 8 dígitos que contenga números, letras y caracteres especiales [@#$%^&+=]!",
    "oneDoc": "El documento ya existe, si desea volver a cargarlo, primero elimínelo",
    "Sunday": "Domingo",
    "Monday": "Lunes",
    "Tuesday": "Martes",
    "Wednesday": "Miércoles",
    "Thursday": "Jueves",
    "Friday": "Viernes",
    "Saturday": "Sábado",
    "input_error": "Todos los campos del formulario no pueden estar vacíos",
    video_tutorial:'Material',
    "view": "Ver en línea",
    "selectDeviceOne": "Este comando solo puede seleccionar un dispositivo para consultar",
    "select_device_list": "Lista de dispositivos seleccionados",
    "small_size": "Pequeño",
    "medium_size": "Mediano",
    "large_size": "Grande",
    device_info:'Información del dispositivo',
    "notification": "Notificación",
    "notif_title": "Contenido de la Notificación",
    "notif_msg": "A partir del 5 de noviembre de 2024, el Centro de Servicios ETV eliminará los materiales almacenados por más de un año. Por favor, tenga en cuenta y haga una copia de seguridad de los materiales importantes con anticipación. Gracias por su comprensión y cooperación.",
    reduce: 'Reducir',
    bound_material: 'Material Vinculado',
    tip_material: 'El material del programa vinculado no se puede eliminar, por favor, desvincule el material primero.',
    boundpo: 'Programa Vinculado',
    bind_progron: 'Este material está vinculado a un programa y no se puede eliminar.',
    index: 'Índice',
    source: 'Fuente',
    getUploadSet_tip: 'Error al obtener la desactivación de la carga de material.',
    getUploadstartTime_tip: 'La carga de materiales está prohibida en este momento. Por favor, cargue durante horas no prohibidas.',
    getUploadendTim: 'Carga de material desactivada',
    "download": "Descargar",
    program_review: 'Revisión del programa',
    pass: 'Aprobar',
    not_passed_or_not_reviewed: 'No aprobado o no revisado',
    play_mode: 'Modo de reproducción',
    review_status: 'Estado de revisión',
    reject: 'Rechazar',
    review_content: 'Contenido de la revisión',
    enter_review_content: 'Por favor, ingrese el contenido de la revisión',
    device_quantity: "Cantidad de dispositivos",
    noMore: 'No hay más',
    "nameLengthLimit": "Por favor, limite la longitud del nombre a 50 caracteres.",
    "customer_title": "Consulta de cuenta",
    "authorized_devices": "Dispositivos autorizados",
    "enable": "Habilitar",
    "disable": "Deshabilitar",
    "expired": "Cuenta caducada",
    "valid_date": "Fecha válida",
    "valid_date_placeholder": "Ingrese fecha válida",
    "capacity_rule": "La capacidad del servidor debe ser múltiplo de 100",
    "capacity_label": "Capacidad del servidor (MB)",
    "download_speed": "Límite de velocidad de descarga",
    "submit_btn": "Enviar",
    "sub_accounts":"Solo se permiten modificaciones de subcuentas",
    plan_mode: 'Modo de Planificación',
    default_mode: 'Modo Predeterminado',
    "help": "Ayuda",
    "network_mode": "Distribución en red",
    "phone_mode": "Modo teléfono",
    "standalone_mode": "Modo independiente",
    "apk_download": "Descargar APK",
    "android": "Android",
    "ios": "iOS",
    "app_name": "ETV-H5 Asistente de publicación de información",
    "info_publish": "Publicación de información",
    "upload_material": "Subir materiales",
    "wx_config_incomplete": "Parámetros de configuración de WeChat incompletos",
    "wx_missing_appid": "Falta appId en la configuración de WeChat",
    "wx_jssdk_not_loaded": "JS-SDK de WeChat no cargado, actualice la página e intente nuevamente",
    "wx_version_not_support_scan": "La versión actual de WeChat no admite la función de escaneo, actualice WeChat",
    "wx_signature_failed": "Error de verificación de firma de WeChat, verifique el algoritmo de firma y la URL en el backend",
    "wx_domain_not_config": "Dominio actual no configurado en la Plataforma Oficial de WeChat, configure el dominio seguro de la interfaz JS",
    "wx_config_failed": "Error de configuración de WeChat",
    "wx_scan_init_failed": "Error al inicializar la función de escaneo de WeChat",
    "browser_not_support_camera": "Su navegador no admite la función de cámara",
    "scan_content_unrecognized": "Contenido escaneado no reconocido, ¡intente nuevamente!",
    "scan_lib_load_failed": "Error al cargar la biblioteca de escaneo, actualice la página e intente nuevamente",
    "wx_scan_not_ready": "Función de escaneo de WeChat no lista, inicializando...",
    "wx_scan_permission_denied": "Permiso de escaneo de WeChat denegado, verifique la configuración de WeChat o actualice la página",
    "scan_connect": "Escanear para conectar",
    "confirm_connect_device": "Confirmar dispositivo de conexión",
    "confirm_connect_device_msg": "¿Conectar con {deviceName}?",
    "data_lost_rescan": "Datos perdidos, escanee nuevamente",
    "connect_failed_retry": "Error de conexión, reintente",
    "qrcode_placeholder": "Por favor, coloque el código QR dentro del marco",
    "camera_unauthorized": "Acceso a la cámara no autorizado",
    "camera_not_found": "Dispositivo de cámara no encontrado",
    "camera_select_failed": "No se puede seleccionar el dispositivo de cámara",
    "camera_start_failed": "Error al iniciar la cámara, haga clic para reintentar",
    "camera_permission_requesting": "Solicitando permiso de cámara",
    "camera_click_to_start": "Haga clic en la pantalla para iniciar la cámara",
    "camera_permission_denied": "Permita el acceso a la cámara, haga clic para reintentar",
    "camera_device_not_found": "Dispositivo de cámara no encontrado",
    "camera_init_failed": "Error al inicializar la cámara, haga clic para reintentar",
    "scanner_not_initialized": "Escáner de código QR no inicializado",
    "scan_start_failed": "Error al iniciar el escaneo de código QR",
    "qrcode_format_error": "Formato de datos del código QR incorrecto",
    "qrcode_verify_success": "Verificación de código QR exitosa",
    "qrcode_verify_failed": "Verificación de código QR fallida",
    "process_failed": "Error de procesamiento",
    "camera_not_found_current": "No se puede encontrar la cámara actual",
    "camera_switch_failed": "No se puede cambiar a otra cámara",
    "camera_no_alternatives": "No se detectaron cámaras alternativas",
  }
}